import { render, staticRenderFns } from "./senhas-painel.vue?vue&type=template&id=0c02c3a0&"
import script from "./senhas-painel.vue?vue&type=script&lang=js&"
export * from "./senhas-painel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports